/**
 * Invitation Actions
 *
 * FETCH_INVITATION is used to fetch all of invitations sent by user.
 * FETCH_INVITATION_ROLE is used to fetch assignable roles for user.
 */
import { createActions } from 'redux-actions';
import ActionFactory from './ActionFactory';
import {
  createAlert,
  createSuccessAlert,
} from './ActionCreators';
import {
  INVITATION,
  GET_INVITATION_LIST,
  GET_ASSIGNABLE_ROLES,
  SEND_INVITATION,
  RESEND_INVITATION,
} from '../constants/ActionTypes';
import { InvitationAPIConnectors } from '../api';

const plainActions = createActions(
  ...Object.values(ActionFactory(GET_INVITATION_LIST)),
  ...Object.values(ActionFactory(GET_ASSIGNABLE_ROLES)),
  ...Object.values(ActionFactory(SEND_INVITATION)),
  ...Object.values(ActionFactory(RESEND_INVITATION)),
  { prefix: INVITATION },
);

const thunkActions = {
  getInvitationList: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getInvitationListRequest());
        const result = await InvitationAPIConnectors.getInvitations();
        dispatch(plainActions.getInvitationListSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getInvitationListFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  getAssignableRoles: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getAssignableRolesRequest());
        const result = await InvitationAPIConnectors.getAssignableRoles();
        dispatch(plainActions.getAssignableRolesSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getAssignableRolesFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  sendInvitation: invitationData => (
    async (dispatch) => {
      try {
        dispatch(plainActions.sendInvitationRequest());
        await InvitationAPIConnectors.sendInvitation(invitationData);
        dispatch(plainActions.sendInvitationSuccess());
        return true;
      } catch (err) {
        dispatch(plainActions.sendInvitationFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  resendInvitation: invitationId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.resendInvitationRequest());
        await InvitationAPIConnectors.resendInvitation(invitationId);
        dispatch(plainActions.resendInvitationSuccess());
        dispatch(createSuccessAlert('Resend invitation succeed.'));
        return true;
      } catch (err) {
        dispatch(plainActions.resendInvitationFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/InvitationActionCreators.js